function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#004A80"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#004A80"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#4FBFEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#4FBFEF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__b",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#004A80"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "33%",
  stopColor: "#004A80"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "33%",
  stopColor: "#006ABC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "66%",
  stopColor: "#006ABC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "66%",
  stopColor: "#009DE6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#009DE6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__c",
  x1: "11.667%",
  x2: "88.333%",
  y1: "82.167%",
  y2: "17.833%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#004A80"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "25%",
  stopColor: "#004A80"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "25%",
  stopColor: "#006ABC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#006ABC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#4FBFEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#4FBFEF"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M94.463 49.368c12.439.004 21.08-9.574 21.08-21.952 0-11.938-9.512-20.781-21.658-20.781H85.03v42.737l9.433-.004zM78 0h18.292C109.902 0 123 11.716 123 27.78 123 43.769 110.34 56 94.536 56H78V0zM139 0L168 0 168 6.631 146.083 6.631 146.083 24.393 168 24.393 168 31.026 146.083 31.026 146.083 49.371 168 49.371 168 56 139 56zM206 9.288l-10.67 27.485h21.335L206 9.288zm13.108 33.678h-26.221L187.777 56H180l22.89-56h6.22L232 56h-7.776l-5.116-13.034zM244 0L251.141 0 251.141 49.368 271 49.368 271 56 244 56zM13.973 6.635L0 6.635 0 0 35 0 35 6.631 21.034 6.631 21.034 56 13.975 56zM51 56L58 56 58 0 51 0z",
  transform: "translate(123 25)"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__a)",
  d: "M89.219 25.186c-5.65-1.678-9.622-6.745-9.9-12.633C70.658 4.546 59.315.068 47.52 0 21.449.414.414 21.449 0 47.52c.414 26.071 21.449 47.106 47.52 47.52 26.071-.414 47.106-21.449 47.52-47.52-.018-7.818-2.021-15.502-5.821-22.334zM47.52 87.12c-21.698-.411-39.189-17.902-39.6-39.6.411-21.698 17.902-39.189 39.6-39.6 21.698.411 39.189 17.902 39.6 39.6-.411 21.698-17.902 39.189-39.6 39.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__b)",
  d: "M13.86 47.52c-.094 4.05.578 8.08 1.98 11.88 1.787 4.467 4.484 8.513 7.92 11.88 6.319 6.283 14.85 9.837 23.76 9.9 8.91-.063 17.441-3.617 23.76-9.9 3.436-3.367 6.133-7.413 7.92-11.88 1.402-3.8 2.074-7.83 1.98-11.88H13.86z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93.06,
  cy: 11.88,
  r: 5.94,
  fill: "url(#prefix__c)"
})));

function SvgLogoColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 394,
    height: 95,
    viewBox: "0 0 394 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo-color.06bb5726.svg";
export { ForwardRef as ReactComponent };